import { Component, OnInit, OnDestroy } from '@angular/core';
import { SubmitRequiredUserInformationRequestModel, SubmitRequiredUserInformationResponseModel, MessageModel } from '../../model/models';
import { FirstTimeLoginService } from '../first-time-login/firstTimeLogin.service';
import { CurrentPageWatcherService } from '../../shared/utils/CurrentPageWatcher';
import { LoginService } from '../login/login.service';
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { Router } from '@angular/router';
import { StorageService } from '../../shared/security/StorageService';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit, OnDestroy {

  title : string ="Enter E-Mail Address";
  submitRequiredUserInformationModel = new SubmitRequiredUserInformationRequestModel();
  userMessages: Array<MessageModel> = [];

  constructor(private firstTimeLoginService:  FirstTimeLoginService, 
    private currentPageWatcherService: CurrentPageWatcherService,
    private loginService : LoginService,
    private spinner: SpinnerService,
    private router : Router,
    private storage: StorageService) { }

  ngOnInit() {

    this.currentPageWatcherService.pageChanged().emit(this.title);

  }


  onContinue() {
    this.currentPageWatcherService.sendUserMessages(null);

      this.submitRequiredUserInformationModel.SessionID=this.storage.getSessionData().userSessionId;
      console.log("submitRequiredUserInformationModel ", this.submitRequiredUserInformationModel);
      this.firstTimeLoginService.firstTimeLogin(this.submitRequiredUserInformationModel)
      .subscribe(
        (requiredUserInfoResponse: SubmitRequiredUserInformationResponseModel)=>{
          console.log("requiredUserInfoResponse ", requiredUserInfoResponse);
          if(requiredUserInfoResponse.UserMessages!=undefined){
          
           requiredUserInfoResponse.UserMessages.forEach(el=>{
              this.userMessages.push(el);
          });
        }
          this.currentPageWatcherService.sendUserMessages(this.userMessages);
          //no error 
          if (requiredUserInfoResponse.Summary == 0) {
            this.router.navigate(["/home"]);
            this.userMessages = [];
          }
          else{
            $("html, body").animate({ scrollTop: 0 }, "slow");
            this.userMessages = [];
  
          }
        },
        
      )
    }
    ngOnDestroy(): void {
      this.currentPageWatcherService.clearUserMessage();
    }
}



// WEBPACK FOOTER //
// ./src/app/login/email/email.component.ts